
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { take, share, tap } from 'rxjs/operators';
import { ClienteApiService } from 'app/api/clienteApi.service';
import { UsuariosService } from 'app/api/usuarios.service';
import { MensagensApiService } from 'app/api/mensagensApi.service';
import { PessoaJuridica } from 'app/model/pessoaJuridica';
import { MensagemEmail } from 'app/model/mensagemEmail';
import { User } from 'app/model/user';

@Component({
  selector: 'app-mensagens-detalhes',
  templateUrl: './mensagens-detalhes.component.html',
  styleUrls: ['./mensagens-detalhes.component.css']
})
export class MensagensDetalhesComponent implements OnInit {


  clientes$: Observable<PessoaJuridica[]>;
  clientes: PessoaJuridica[];
  mensagem$: Observable<MensagemEmail[]>;
  usuario$: Observable<User>;
  usuarioLogado: User;
  idMensagem: number;

  constructor(
    private mensagensService: MensagensApiService,
    private clientesService: ClienteApiService,
    private usuarioService: UsuariosService,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.idMensagem = +this.route.snapshot.paramMap.get('Id');
    this.usuario$ = this.usuarioService.v1UsuariosLogadoGet().pipe(share());
  }

  ngOnInit() {
    this.usuario$.forEach(usuarioLogado => this.usuarioLogado = usuarioLogado);
    this.getMensagemById();
    this.getClientes();
  }

  getMensagemById() {
    this.mensagem$ = this.mensagensService.v1MensagensMensagemIdGet(this.idMensagem).pipe(share());
  }

  getClientes() {
    this.clientes$ = this.clientesService.v1ClienteGet().pipe(share(),
    tap(clientes => this.clientes = clientes));
  }


  goBack(): void {
    this.location.back();
  }

}
